import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/ASM/ACCURATE_SCREW_MACHINE_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const ASM_SITE_INFORMATION = [
  '10 Audrey Place',
  'Fairfield, NJ 07004',
  'Phone (973) 244 - 9200',
  'Fax (877) 285 - 2181',
  'FEIN: 38-2938499',
  'CAGE Code: 51506',
];

export function ASMQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} extraStyles={[{ height: '25px' }]} />

        <SiteInformation
          name="Accurate Screw Machine"
          items={ASM_SITE_INFORMATION}
        />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} showCustomerPartId />

            <PartDescription description={part.description} />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>*****SHIP POLICY: 15 DAYS EARLY / 2 DAYS LATE *****</Text>
          <Text>{'\n'}</Text>
          <Text style={[styles.bold, styles.textSmall]}>
            NOTE: Quantity break prices are stated above, however you can order
            the specific quantity needed. Please include the ASQ number on any
            order. Our MGF CofC is included at no cost with every shipment. If
            chem/phys test reports are required, these are an additional $100
            per item. If a First Article Inspection Report (FAIR) is required,
            this is an additional $750 fee. If the FAIR needs to be completed
            through NetInspect the fee is $1,000. This report includes chem/phys
            certs. Please specific if NADCAP approved processors are required.
            This comes at additional costs. CONDITIONS OF SALE: 1. NO CONTRACT
            SHALL EXIST UNTIL SELLER RECEIVES ORDER FOR DELIVERY PLACED BY
            BUYER. 2. PRICES ARE SUBJECT TO CHANGE TO CONFORM TO PRICES
            PREVAILING AT TIME OF SHIPMENT. 3. PRICES ARE SUBJECT TO PRODUCTION
            RELEASES. WHERE REVISIONS RESULT IN HIGHER COSTS PRICES ARE SUBJECT
            TO CHANGE. 4. ALL PRICES ARE SUBJECT TO CHANGE TO CONFORM TO ALL
            STATE AND FEDERAL LAWS. 5. CHARGES MADE FOR TOOLS AND DIES DO NOT
            CONVEY THE RIGHT TO REMOVE THEM FROM OUR FACTORY. 6. IF ANY MATERIAL
            IS PROVED DEFECTIVE, SELLERS LIABILITY IS LIMITED TO REPLACEMENT
            ONLY AND SELLER WILL NOT PAY ANY CLAIM FOR LABOR ON OR FOR DAMAGE BY
            REASON OF ITS USE. 7. THE SELLER SHALL NOT BE LIABLE FOR
            INFRINGEMENT OF ANY PATENTS REQUIRED TO BE USED BY THE
            SPECIFICATIONS OF THE BUYER AND THE BUYER AGREES TO SAVE THE SELLER
            HARMLESS FOR ALL JUDGEMENTS, DECREES, COSTS AND OTHER LEGAL EXPENSES
            RESULTING FROM ANY SUITS AND AGREES TO DEFEND SELLER SHOULD SUCH A
            SUIT BE INSTITUTED. 8. GOODS SHALL BE INSPECTED WHEN RECEIVED AND
            THE SELLER IS NOT LIABLE FOR ANY DEFECTS UNLESS NOTIFIED WITHIN 30
            DAYS AFTER RECEIPT BY THE BUYER. 9. WE RESERVE THE RIGHT TO OVER AND
            UNDER SHIP BY ANY AMOUNT NOT TO EXCEED TEN PERCENT OF SPECIFIED
            QUANTITY. 10. ALL AGREEMENTS ARE CONTINGENT UPON STRIKES, ACCIDENTS
            AND OTHER DELAYS UNAVOIDABLE OR BEYOND OUR CONTROL.
          </Text>
          <Text>{'\n'}</Text>
          <Text>
            Standard terms and conditions can be found on www.mwcomponents.com
            &lt;https://www.mwcomponents.com/mw-industries-terms-and-conditions&gt;
          </Text>
        </View>
      </View>
    </Page>
  );
}
